<div class="card upload-drop-zone" ngFileDrop
     (uploadOutput)="onUploadOutput($event)" [uploadInput]="uploadInput"
     [ngClass]="{ 'is-drop-over': dragOver }">

  <div class="card-block">
    <div class="row mt-5 mb-5">
      <div class="col-sm-12 text-center">
        <img src="/assets/images/icons/folders_green.png" alt="cards-upload"/>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 drop-text">
        Drop an image or
        <label class="upload-button">
          <input type="file" accept="image/png, image/jpeg" ngFileSelect (uploadOutput)="onUploadOutput($event)" [uploadInput]="uploadInput">
          browse
        </label><br />
        it from your computer
      </div>
    </div>
  </div>

  <div *ngIf="files.length" class="card-block">
    <div class="row">
      <div class="col-sm-12 text-center">
        <div class="spinner-bar" *ngIf="!allUploadDone && uploading"></div>
        <div class="all-upload-done" *ngIf="allUploadDone && !uploading">
          <i class="fa fa-check-circle fa-2x"></i>
        </div>
        <div class="files">
          <div class="filename mt-2" *ngFor="let file of files">{{ file.name }} <i *ngIf="file.progress.status==done" class="fa fa-check"></i></div>
        </div>
      </div>
    </div>
    <div class="row mb-5 mt-4" *ngIf="uploading">
      <div class="col-sm-6 offset-sm-3 text-center">
        <p><ngb-progressbar class="mb-4" type="success" [value]="uploadPercent"></ngb-progressbar></p>

        <div class="percent-bar" *ngIf="uploadPercent <= 99.99">
          <span class="remaining-size">{{ remaining }}</span> / {{ total }} ({{speed}})
        </div>
        <div class="waiting-for-convertation" *ngIf="uploadPercent > 99.99">
          Processing image...
        </div>

      </div>
    </div>
  </div>

  <div *ngIf="!uploading" class="card-block mb-5">
    <div class="folder-select">
      <ng2-completer (selected)="onFolderSelected($event)" [openOnFocus]="true" [textNoResults]="'No results, but `' + folderSearchQuery + '` will be created on-the-fly.'" [(ngModel)]="folderSearchQuery" [placeholder]="'Add to specific folder?'" [datasource]="dataService" [minSearchLength]="1"></ng2-completer>
      <!--div class="text-center">
        <button type="button" class="btn btn-primary mt-3" (click)="createFolder()" *ngIf="noResultsForFolder">Create Folder</button>
      </div-->
    </div>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/media-library/upload-media/upload-media.component.html